module.exports = __webpack_public_path__ + "web-mobile-dev.svg?9e677ce516baacecc0c629768fad18cf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/web-mobile-dev.svg
// module id = 129
// module chunks = 0